import { render } from "./Auth.vue?vue&type=template&id=56d4013e&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"

import "./Auth.vue?vue&type=style&index=0&id=56d4013e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-56d4013e"

export default script